/* Sayfa masaüstü bildirimi çizmeli mi? Saf karar — DOM'a dokunmaz, test edilebilir.

   TEK KAYNAK KURALI: web push etkinken bildirimi service worker çizer. Sayfa da çizerse
   kullanıcı aynı olayı iki kez görür. `force` yalnız web push kapısını aşar; izin ve
   liderlik kurallarını ASMAZ (izinsiz bildirim zaten çizilemez, lidersiz çizim çift
   bildirim demektir). */

export function shouldShowPageNotification({
    permission,
    hasWebPushToken,
    isLeader,
    prefEnabled,
    force = false,
}) {
    if (permission !== 'granted') return false;
    if (!isLeader) return false;
    if (!prefEnabled) return false;
    if (hasWebPushToken && !force) return false;
    return true;
}
